import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mubiao",
  "use": "icon-mubiao-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" stroke=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mubiao\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 12L38 42H4L21 12Z\" stroke-width=\"4\" stroke-linejoin=\"round\" /><path d=\"M36.5 42H44L36 28L33 33\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M21 12L13 42\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol